import dayjs from "dayjs"
import { ResponseDailyCuts } from "../response"
import { Constants } from "../../../utils/constants"

const formatDailyCutsResponse = ({ response }: { response: ResponseDailyCuts }) => {

    const totalPages = !response.errors ? response.totalPages:1
    const totalCuts = !response.errors ? response.totalItems:0
    const row = !response.errors ? response?.items.map((item) => {
        return {
            id: item.dailyCutLogId,
            title: item.name,
            dateGeneration: dayjs(item.dateCut).format(Constants.dayjsFormatDate),
            reportUrl: item.reportUrl
        }
    }) : []

    return {
        row, totalPages, totalCuts
    }
}

export { formatDailyCutsResponse }